var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiModel } from "../api-model";
var BaseMetadatas = /** @class */ (function (_super) {
    __extends(BaseMetadatas, _super);
    function BaseMetadatas(data) {
        return _super.call(this, data) || this;
    }
    return BaseMetadatas;
}(ApiModel));
export { BaseMetadatas };



// WEBPACK FOOTER //
// ./src/app/models/metadata/base-metadatas.model.ts.pre-build-optimizer.js